import React, { PropTypes } from 'react';

class ClubEditComponent extends React.Component {
  static propTypes = {
    model: PropTypes.object
  };

  render() {
    return (
      <div>ClubEditComponent</div>
    );
  }
}

export default ClubEditComponent;




// WEBPACK FOOTER //
// ./src/components/Clubs/ClubEdit/component.jsx